module.exports = __webpack_public_path__ + "img/Young-Boys.3c1d659f.png";